<div *ngIf="alerts.length">
  <div *ngFor="let alert of alerts" class="{{cssClass(alert)}}" id="ap-alert-{{alert.id}}-{{alert.htmlBaseId}}">
    <span [innerHTML]="alert.message"></span>
    <a class="close"
       id="ap-alert-{{alert.id}}-{{alert.htmlBaseId}}-close"
       (click)="removeAlert(alert)">&times;</a>
  </div>
</div>
<div class="alert-errors-container" *ngIf="alertErrors.length">
  <div *ngFor="let alert of alertErrors" class="{{cssClass(alert)}}" id="ap-alert-errors-{{alert.id}}-{{alert.htmlBaseId}}">
    <span [innerHTML]="alert.message"></span>
    <a class="close"
       id="ap-alert-error-{{alert.id}}-{{alert.htmlBaseId}}-close"
       (click)="removeAlert(alert)">&times;</a>
  </div>
</div>
